import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 秋霞影院影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500/95 px-2 py-1 text-xs font-semibold text-white">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-primary-900/90 font-heading text-sm font-bold text-accent-400">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 right-2 rounded-md bg-primary-950/80 px-2 py-0.5 text-[11px] text-background-100">
          {movie.year}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-primary-950/95 to-transparent p-3 pt-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="flex w-full items-center justify-center gap-1 rounded-md bg-accent-500 py-2 text-xs font-semibold text-white">
            <i className="ri-play-fill" /> 查看详情
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
            {movie.type === "movie" ? "电影" : "剧集"}
          </span>
          <span className="whitespace-nowrap">{movie.genre.slice(0, 2).join(" · ")}</span>
        </div>
      </div>
    </Link>
  );
}